"use strict";
/**
 * @deprecated
 * 此文件不再继续使用和维护
 * 使用Network代替
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableUtils = void 0;
const axios_1 = __importDefault(require("axios"));
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const dataRetrive_1 = require("../dataRetrive");
const Error_1 = require("../error/Error");
const ObservableUtilsHelper_1 = require("./ObservableUtilsHelper");
const Tools_1 = require("./Tools");
/**
 * @deprecated
 * 使用Network代替
 */
exports.ObservableUtils = {
    /**
     * @deprecated
     * 使用Network代替
     */
    _buildUrlWithParam(url, params = {}) {
        const commonParam = (0, dataRetrive_1.getTradeDependencyInstance)().getRunTimeHost().commonParam || {};
        const fullParams = Object.assign(Object.assign({}, commonParam), params);
        const queryString = Object.keys(fullParams)
            .filter((key) => fullParams[key] !== undefined)
            .map((key) => {
            return `${key}=${encodeURIComponent(fullParams[key])}`;
        }, [])
            .join("&");
        if (queryString) {
            return `${url}${url.includes("?") ? "&" : "?"}${queryString}`;
        }
        else {
            return url;
        }
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    buildUrlWithCommonParams(url, commonParam) {
        return this._buildUrlWithParam(url, commonParam);
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    createPostRequestObservable(url, headers, body, parseCallback) {
        return (0, rxjs_1.from)(axios_1.default.post(url, body, (0, Tools_1.createAxiosRequestConfig)(url, headers)))
            .pipe((0, operators_1.map)((res) => {
            const resp = res.data;
            if ("code" in resp) {
                if (resp.code === 0) {
                    return parseCallback(resp);
                }
                else {
                    throw res;
                }
            }
            else {
                return parseCallback(resp);
            }
        }))
            .pipe((0, operators_1.catchError)((err) => {
            throw Error_1.ErrorGenerate.formatterError(err);
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    createGetRequestObservableV2(url, headers, params, parseCallback) {
        return (0, rxjs_1.from)(axios_1.default.get(url, (0, Tools_1.createAxiosRequestConfig)(url, headers, params)))
            .pipe((0, operators_1.map)((res) => {
            const resp = res.data;
            if ("code" in resp) {
                if (resp.code === 0) {
                    return parseCallback(resp);
                }
                else {
                    throw res;
                }
            }
            else {
                return parseCallback(resp);
            }
        }))
            .pipe((0, operators_1.catchError)((err) => {
            throw Error_1.ErrorGenerate.formatterError(err);
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    createGetRequestObservable(url, headers, parseCallback) {
        return this.createGetRequestObservableV2(url, headers, undefined, parseCallback);
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    createPutRequestObservable(url, headers, body, parseCallback) {
        return (0, rxjs_1.from)(axios_1.default.put(url, body, (0, Tools_1.createAxiosRequestConfig)(url, headers)))
            .pipe((0, operators_1.map)((res) => {
            const resp = res.data;
            if ("code" in resp) {
                if (resp.code === 0) {
                    return parseCallback(resp);
                }
                else {
                    throw res;
                }
            }
            else {
                return parseCallback(resp);
            }
        }))
            .pipe((0, operators_1.catchError)((err) => {
            throw Error_1.ErrorGenerate.formatterError(err);
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    createPatchRequestObservable(url, headers, body, parseCallback) {
        return (0, rxjs_1.from)(axios_1.default.patch(url, body, (0, Tools_1.createAxiosRequestConfig)(url, headers)))
            .pipe((0, operators_1.map)((res) => {
            const resp = res.data;
            if ("code" in resp) {
                if (resp.code === 0) {
                    return parseCallback(resp);
                }
                else {
                    throw res;
                }
            }
            else {
                return parseCallback(resp);
            }
        }))
            .pipe((0, operators_1.catchError)((err) => {
            throw Error_1.ErrorGenerate.formatterError(err);
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    createDeleteRequestObservableV2(url, headers, params, parseCallback) {
        return (0, rxjs_1.from)(axios_1.default.delete(url, (0, Tools_1.createAxiosRequestConfig)(url, headers, params)))
            .pipe((0, operators_1.map)((res) => {
            const resp = res.data;
            if ("code" in resp) {
                if (resp.code === 0) {
                    return parseCallback(resp);
                }
                else {
                    throw res;
                }
            }
            else {
                return parseCallback(resp);
            }
        }))
            .pipe((0, operators_1.catchError)((err) => {
            throw Error_1.ErrorGenerate.formatterError(err);
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    createDeleteRequestObservable(url, headers, parseCallback) {
        return this.createDeleteRequestObservableV2(url, headers, undefined, parseCallback);
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    postWithTradeAuthV3(url, param, data, headers = {}) {
        return (0, dataRetrive_1.getTradeDependencyInstance)()
            .getTradingToken()
            .pipe((0, operators_1.flatMap)((tradingTokenInfo) => {
            if (!tradingTokenInfo) {
                throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.TradeUnAuthorized, "trade_unAuthorized", { url: url });
            }
            else {
                const authHeader = Object.assign(Object.assign({}, headers), { Authorization: `Bearer ${tradingTokenInfo.tradingToken}` });
                return exports.ObservableUtils.post(url, data, authHeader);
            }
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    getWithTradeAuthV3(url, param, params, headers = {}) {
        return (0, dataRetrive_1.getTradeDependencyInstance)()
            .getTradingToken()
            .pipe((0, operators_1.flatMap)((tradingTokenInfo) => {
            if (!tradingTokenInfo) {
                throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.TradeUnAuthorized, "trade_unAuthorized", { url: url });
            }
            else {
                const authHeader = Object.assign(Object.assign({}, headers), { Authorization: `Bearer ${tradingTokenInfo.tradingToken}` });
                return exports.ObservableUtils.get(url, params, authHeader);
            }
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    getWithAccessAndSpotAuth(url, keyInfo, params, headers = {}) {
        return (0, ObservableUtilsHelper_1.AccessAndSpotAuthHeaderObservable)(headers).pipe((0, operators_1.flatMap)((authHeader) => {
            return exports.ObservableUtils.get(url, params, authHeader);
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    getWithAccessAndTraderAuth(url, params, headers = {}) {
        return (0, ObservableUtilsHelper_1.AccessAndTraderAuthHeaderObservable)(headers).pipe((0, operators_1.flatMap)((authHeader) => {
            return exports.ObservableUtils.get(url, params, authHeader);
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    postWithAccessAndSpotAuth(url, keyInfo, body, headers = {}) {
        return (0, ObservableUtilsHelper_1.AccessAndSpotAuthHeaderObservable)(headers).pipe((0, operators_1.flatMap)((authHeader) => {
            return exports.ObservableUtils.post(url, body, authHeader);
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    deleteWithAccessAndSpotAuth(url, keyInfo, params, headers = {}) {
        return (0, ObservableUtilsHelper_1.AccessAndSpotAuthHeaderObservable)(headers).pipe((0, operators_1.flatMap)((authHeader) => {
            return exports.ObservableUtils.delete(url, params, authHeader);
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    postV2(url, data, headers = {}, authorize = false) {
        let requestObservable;
        if (authorize) {
            requestObservable = (0, dataRetrive_1.getTradeDependencyInstance)()
                .getAccessToken()
                .pipe((0, operators_1.flatMap)((token) => {
                if (!token) {
                    throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.tokenUnAuthorized, "UnAuthorized");
                }
                const header = Object.assign(Object.assign({}, headers), { Authorization: `Bearer ${token}`, "Content-Type": "application/json;charset=UTF-8" });
                return this.createPostRequestObservable(url, header, data, (response) => {
                    return response;
                });
            }));
        }
        else {
            requestObservable = this.createPostRequestObservable(url, headers, data, (response) => {
                return response;
            });
        }
        return (0, Tools_1.resolveResponse)(requestObservable);
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    post(url, data, headers = {}, authorize = false) {
        let requestObservable;
        if (authorize) {
            requestObservable = (0, dataRetrive_1.getTradeDependencyInstance)()
                .getAccessToken()
                .pipe((0, operators_1.flatMap)((token) => {
                if (!token) {
                    throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.tokenUnAuthorized, "UnAuthorized");
                }
                const header = Object.assign(Object.assign({}, headers), { Authorization: token, "Content-Type": "application/json;charset=UTF-8" });
                return this.createPostRequestObservable(url, header, data, (response) => {
                    return response;
                });
            }));
        }
        else {
            requestObservable = this.createPostRequestObservable(url, headers, data, (response) => {
                return response;
            });
        }
        return (0, Tools_1.resolveResponse)(requestObservable);
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    getV2(url, params, headers = {}, authorize = false) {
        let requestObservable;
        if (authorize) {
            requestObservable = (0, dataRetrive_1.getTradeDependencyInstance)()
                .getAccessToken()
                .pipe((0, operators_1.flatMap)((token) => {
                if (!token) {
                    throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.tokenUnAuthorized, "UnAuthorized");
                }
                const header = Object.assign(Object.assign({}, headers), { Authorization: `Bearer ${token}`, "Content-Type": "application/json;charset=UTF-8" });
                return this.createGetRequestObservableV2(url, header, params, (resp) => {
                    return resp;
                });
            }));
        }
        else {
            requestObservable = this.createGetRequestObservableV2(url, undefined, params, (resp) => {
                return resp;
            });
        }
        return (0, Tools_1.resolveResponse)(requestObservable);
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    get(url, params, headers = {}, authorize = false) {
        let requestObservable;
        if (authorize) {
            requestObservable = (0, dataRetrive_1.getTradeDependencyInstance)()
                .getAccessToken()
                .pipe((0, operators_1.flatMap)((token) => {
                if (!token) {
                    throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.tokenUnAuthorized, "UnAuthorized");
                }
                const header = Object.assign(Object.assign({}, headers), { Authorization: token, "Content-Type": "application/json;charset=UTF-8" });
                return this.createGetRequestObservableV2(url, header, params, (resp) => {
                    return resp;
                });
            }));
        }
        else {
            requestObservable = this.createGetRequestObservableV2(url, headers, params, (resp) => {
                return resp;
            });
        }
        return (0, Tools_1.resolveResponse)(requestObservable);
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    delete(url, params = {}, headers = {}, authorize = false) {
        let requestObservable;
        if (authorize) {
            requestObservable = (0, dataRetrive_1.getTradeDependencyInstance)()
                .getAccessToken()
                .pipe((0, operators_1.flatMap)((token) => {
                if (!token) {
                    throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.tokenUnAuthorized, "UnAuthorized");
                }
                const header = Object.assign(Object.assign({}, headers), { Authorization: `Bearer ${token}`, "Content-Type": "application/json;charset=UTF-8" });
                return this.createDeleteRequestObservableV2(url, header, params, (resp) => {
                    return resp;
                });
            }));
        }
        else {
            requestObservable = this.createDeleteRequestObservableV2(url, headers, params, (resp) => {
                return resp;
            });
        }
        return (0, Tools_1.resolveResponse)(requestObservable);
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    postThrowable(url, data, headers = {}, authorize = false) {
        let requestObservable;
        if (authorize) {
            requestObservable = (0, dataRetrive_1.getTradeDependencyInstance)()
                .getAccessToken()
                .pipe((0, operators_1.flatMap)((token) => {
                if (!token) {
                    throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.tokenUnAuthorized, "UnAuthorized");
                }
                const header = Object.assign(Object.assign({}, headers), { Authorization: token, "Content-Type": "application/json;charset=UTF-8" });
                return (0, rxjs_1.from)(axios_1.default.post(url, data, (0, Tools_1.createAxiosRequestConfig)(url, header)));
            }));
        }
        else {
            requestObservable = (0, rxjs_1.from)(axios_1.default.post(url, data, (0, Tools_1.createAxiosRequestConfig)(url, headers)));
        }
        return requestObservable;
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    getCDN(url, header) {
        const _header = Object.assign({ "Cache-Control": "max-age=0", "Content-Type": "application/json;charset=UTF-8" }, header);
        return (0, rxjs_1.from)(axios_1.default.get(url, { headers: _header })).pipe((0, operators_1.map)((response) => response.data));
    },
};
